export default "__VITE_ASSET__f85de0c4__"